import axiosInstance from './axios';

/**
 * Generic HTTP Methods Wrapper for RUTEX Backoffice
 */
export const ApiMethods = {
  /**
   * Perform HTTP GET request
   * @param {string} url 
   * @param {object} config 
   */
  get: async (url, config = {}) => {
    const response = await axiosInstance.get(url, config);
    return response.data;
  },

  /**
   * Perform HTTP POST request
   * @param {string} url 
   * @param {object} data 
   * @param {object} config 
   */
  post: async (url, data = {}, config = {}) => {
    const response = await axiosInstance.post(url, data, config);
    return response.data;
  },

  /**
   * Perform HTTP PUT request
   * @param {string} url 
   * @param {object} data 
   * @param {object} config 
   */
  put: async (url, data = {}, config = {}) => {
    const response = await axiosInstance.put(url, data, config);
    return response.data;
  },

  /**
   * Perform HTTP PATCH request
   * @param {string} url 
   * @param {object} data 
   * @param {object} config 
   */
  patch: async (url, data = {}, config = {}) => {
    const response = await axiosInstance.patch(url, data, config);
    return response.data;
  },

  /**
   * Perform HTTP DELETE request
   * @param {string} url 
   * @param {object} config 
   */
  delete: async (url, config = {}) => {
    const response = await axiosInstance.delete(url, config);
    return response.data;
  }
};

export default ApiMethods;
